import { isRef, isVNode } from 'vue'
import { isHTMLElement } from '../is'

export const unwrapElementRef = (elem: any): HTMLElement | undefined => {
  if (!elem) return undefined
  if (isRef(elem)) return unwrapElementRef(elem.value as any)
  if (elem.$el && isHTMLElement(elem.$el)) return elem.$el
  //if ((elem as any).$el) return (elem as any).$el
  const el = isVNode(elem) ? elem.el : elem
  return el as HTMLElement
}

export type ElementRect = {
  x: number;
  y: number;
  width: number;
  height: number;
}
export const unwrapElementRect = (elem: any): ElementRect => {
  const emptyRect: ElementRect = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  try {
    const el = unwrapElementRef(elem);
    const rect = el ? el.getBoundingClientRect() : null;

    if (rect) {
      return {
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height
      }
    }

    return emptyRect; 
  } catch (e) {
    console.error(e);
  }
  
  return emptyRect;
}
